import React from 'react'
import { Row, Col, Space, Typography, Form, Input, Button, Select, Spin } from 'antd'

import './cytoscape.js-panzoom.css'

const { TextArea } = Input
const { Paragraph } = Typography

class GeneNetwork extends React.Component {
    state = {
        datasource: '',
        network: '',
        geneids: '',
        disabled: false,
        spinning: false,
    }

    formRef = React.createRef()

    onFinish = (values) => {
        this.setState({
            disabled: true,
            spinning: true,
        })

        let { geneids } = values
        geneids = geneids.replace(/[\r\n]/g, ",")
        let glist = geneids.split(',')
        
        const { datasource, network }  = this.state
        if (datasource && network) {
            network.setSelectGenes(glist)
            let retrivenwUrl = 'http://solomics.agis.org.cn/tomato/api/v1/gene_network/' + geneids
            // 当前为读取文件中，改为数据库操作时，需要将同步操作改成异步操作
            // 使用ajax数据返回时，使用 ds.remoteSelect
            datasource.remoteSelect(retrivenwUrl).then(records => {
                //network_res = records
                network.draw(records)

                this.setState({
                    disabled: false,
                    spinning: false,
                })
            })
        }
    }

    onReset = () => {
        this.formRef.current.resetFields()
    }

    componentDidMount() {
        const svgViewer = window.svgViewer
        let ds = new svgViewer.DataSource()
            // 参数1：是外层元素ID
            // 参数2：配置选项
        let network = new svgViewer.Network({
            el: '#networkViewer',
                // 色值1：普通节点色值
                // 色值2：被选择节点色值
                // 色值3：边色值
            colors: ['#286090', '#28a745', '#999999'],
                // 第一个为鼠标左击事件
                //    参数1：整个网对象
                //    参数2：被点击节点对象
                //    参数3：点击事件对象
                /*
            events: {
                leftClick: function (cy, node, event) {
                    let cur_id = node.id()
                    console.log(cur_id)
                    let filter_network_res = $(network_res).filter(function(i,n){
                            return n.source == cur_id || n.target == cur_id
                    });
                    console.log(filter_network_res)
                    let html = '<p style="text-align:center;"><a href="/feature/' + cur_id + '"><b>' + cur_id + '</b></a></p>'
                    html += '<p><a href="/zmap_gene_network/geneids/' + cur_id + '">' + 'Browse all connections with this Gene' + '</a></p>'
                    html += '<p>Connections in the current result:</p>'
                    html += '<table><tr><th>Gene</th><th>Score</th></tr>'
                    $(filter_network_res).each(function(i,e){
                            if (e.source == cur_id){
                                    html += '<tr><td><a href="/feature/' + e.target + '">' + e.target + '</a></td><td>' + e.distance + '</td></tr>'
                            } else if (e.target == cur_id){
                                    html += '<tr><td><a href="/feature/' + e.source + '">' + e.source + '</a></td><td>' + e.distance + '</td></tr>'
                            }
                    })
                    html += '</table>'
                    $('#geneinfo').html(html)
                }
            },
            */
                // 是否显示工具条
                // 当前仅包含导出png工具
                // 默认为true
            showTool: true,
        })

        this.setState({
            datasource: ds,
            network: network
        })
    }

    render() {
        const { disabled, spinning } = this.state

        const layout = {
            labelCol: {
                md: { span: 4 },
                xxl: { span: 3 }
            },
            colon: false
        }

        return (
            <React.Fragment>
                <Form {...layout} labelAlign="left" name="gene-network" ref={this.formRef} onFinish={this.onFinish}>
                    <Paragraph>
                        <p>Search for gene network connections. e.g. Solyc01T002021.1</p>
                        The results will plot query genes as green dots and all connected genes as blue dots. 
                        The results could be filtered by set the score cut-off in the lower-left of the network panel. 
                        Certain gene could be located by search for the gene IDs in the upper-right of the network panel.
                    </Paragraph>
                    <Form.Item name="geneids" rules={[{ required: true }]} >
                        <TextArea allowClear rows={8} placeholder="Enter Gene IDs here, separate genes with comma or new line. e.g. Solyc01T002021.1"></TextArea>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Proceed Gene Prioritization
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Row>
                    <div id="networkViewer" style={{position: 'relative', width:'100%'}}><Spin size="large" spinning={spinning} /></div>
                </Row>
            </React.Fragment>
        )
    }
}

export default GeneNetwork
